import BookmarkModule from "../store/modules/bookmark";
import DialogModule from "../store/modules/dialog";
import AppModule from "../store/modules/app";
import { $t } from "../i18n";
import router from "../router";
export default function BookmarkMenu() {
    const { deleteBookmark, list: bookmarks } = BookmarkModule();
    const { openConfirmDialog, setConfirmOptions } = DialogModule();
    const { navigateReload } = AppModule();
    const navigate_bookmark = function(bookmarks) {
        let new_link = bookmarks[0].link.replace(/^\/app/, "");
        new_link = new_link.replaceAll('active_bookmark_id', 'x');
        new_link += "&active_bookmark_id=" + bookmarks[0].id
        // console.log('new_link', new_link)
        navigateReload({ path: new_link })
    };
    const f_bookmarks = function(name) {
        return bookmarks.value.filter(x => x.type === name);
    };
    const activeBookmarkRule = item => {
        var url = new URL(window.location.href);
        var activeBookmarkId = url.searchParams.get("active_bookmark_id");

        if (item.link === window.location.pathname + window.location.search) {
            return true
        }

        return activeBookmarkId && activeBookmarkId === String(item.id)
    };
    const onDeleteBookmarkClick = bookmark => {
        const onDeleteBookmarkConfirm = () => {
            deleteBookmark(bookmark.id);
        };
        setConfirmOptions({
            title: $t("Notice!"),
            text: $t("Are you sure that you want to delete this?"),
            confirm_text: $t("Confirm"),
            cancel_text: $t("Cancel"),
            action: onDeleteBookmarkConfirm
        });
        openConfirmDialog();
    };
    return {
        navigate_bookmark,
        f_bookmarks,
        activeBookmarkRule,
        onDeleteBookmarkClick
    };
}
